var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-checkbox',{attrs:{"color":_vm.color,"vs-value":_vm.vsValue,"icon-pack":_vm.icon[0],"icon":'fa-' + _vm.icon[1]},model:{value:(_vm.localState),callback:function ($$v) {_vm.localState=$$v},expression:"localState"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }